<div class="imageblock ratioblock one"
  [matTooltip]="tooltip$$()"
  [matTooltipDisabled]="loading$$()"
  [matTooltipPosition]="tooltipPosition$$()"
  [style.width]="size$$()"
  >
  <div class="frame" [class.border-line]="border$$()" [class.highlight]="highlight$$()">
    @if (guidPath$$() && (!loading$$() || !this.hideOnLoading$$())) {
      <img alt="" [src]="guidPath$$()" (load)="emit_onLoaded(); onImgLoad($event)">
    } @else if (url$$() && (!loading$$() || !this.hideOnLoading$$())) {
      <img alt="" [src]="version$$() ? url$$() + '?v=' + version$$() : url$$()" (load)="emit_onLoaded(); onImgLoad($event)">
    } @else if (!url$$() && (!loading$$() || !this.hideOnLoading$$())) {
      <ng-content />
    }
  </div>
</div>
